module.exports = __webpack_public_path__ + "static/img/6.5892ac3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/eng/6.png
// module id = INej
// module chunks = 0